import React from 'react';
import { 
	func, 
	object ,
} from 'prop-types';

class Container extends React.PureComponent {
	static propTypes = {
		render : func.isRequired,
		profileReducer : object.isRequired
	}

	constructor(props) {
		super(props);
		this.state = {
		};
	}
	
	render(){
		const {render,profileReducer,...other} = this.props;
		return render({
			imageUrl : profileReducer.imageUrl,
			userName : profileReducer.userName,
			favs : profileReducer.favs,
			uid : profileReducer.uid
		},
		other);
	}
}

export default Container;
